import React, { useState, useEffect, useContext } from "react";
import { Formik } from "formik";
import {
  CensusAndPayroll,
  Census,
  Payroll,
  jsonToStringConverter,
  stringToFunctionConverter,
  stringToJsonConverter,
} from "../../utils";
import { Form } from "react-bootstrap";
import TargetSection from "../../containers/Mapper/MapAndTransformOutput/TargetSection";
import {
  SliderPanel,
  SourceFieldPanelComponent,
  LoaderWrapper,
} from "../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-solid-svg-icons";
import { DragDropContext } from "react-beautiful-dnd";
import RuleFunctionsComponent from "./RuleFunctionsComponent";
import { get, isEqual, isNull } from "lodash";
import {
  manageMapperStore,
  MANAGE_MAPPER_POST_API_ERROR,
  setManageMapperToastInfo,
  setMapperPostResponse,
} from "../../contexts";
import { onSaveMapAndTransformOutput } from "./../../services/mapper/index";
import { fixedWidthOutputMappingSave } from "../../services";
const RuleFilterSlider = (props) => {
  const {
    setFieldValue,
    setShowSlide,
    preValue,
    setPreValue,
    fieldName,
    mappedData,
    setMappedData,
    dataModel,
    fieldIndex,
    innerFieldIndex,
    index,
    showSlide,
    hasHeader,
    sectionType,
    fieldArrayName,
    setFieldArrayName,
    profileId,
    mapType = 0,
    masterSourceDate,
    sourceHeaderName,
  } = props;
  const { state, dispatch } = useContext(manageMapperStore);
  const isEdit = !(fieldIndex == undefined || fieldIndex == null);
  const [clickToSelect, setClickToSelect] = useState(false);
  const [disabledKeys, setDisabledKeys] = useState([]);
  const [headerError, setHeaderError] = useState(false);
  const [valueError, setValueError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [configureValue, setConfigureValue] = useState();
  const [key, setKey] = useState("Header");
  const [saveData, setSaveData] = useState([]);

  const sections = () => {
    switch (dataModel) {
      case 1:
        return [
          {
            name: "Payroll",
            fields: Payroll,
          },
        ];
      case 2:
        return [
          {
            name: "Census",
            fields: Census,
          },
        ];
      case 3:
        return [
          {
            name: "Payroll and Census",
            fields: CensusAndPayroll,
          },
        ];
      case 4:
        return [
          {
            name: "",
            fields: masterSourceDate,
          },
        ];
      default:
        return [
          {
            name: "Census And Payroll",
            fields: CensusAndPayroll,
          },
        ];
    }
  };
  const [section] = sections();

  const apiCall = (data) => {
    let objectMaps = data?.map((item, index) => {
      return {
        ...item,
        mappingOutputProfileId: profileId ?? 0,
        sortOrder: index,
      };
    });
    onSaveMapAndTransformOutput(
      { id: profileId ?? 0, mappingObjectMaps: objectMaps },
      dispatch,
      state
    )
      .then((response) => {
        if (response) {
          setLoading(false);
          let res = {
            ...response,
            mappingObjectMaps: response?.mappingObjectMaps?.filter(
              (_) => !_.isDeleted
            ),
          };
          dispatch(setMapperPostResponse(res));
          dispatch(
            setManageMapperToastInfo({
              showToast: true,
              toastMessage: "Data saved successfully",
            })
          );
          onClose();
        }
      })
      .catch((error) => {
        setLoading(false);
        dispatch({
          type: MANAGE_MAPPER_POST_API_ERROR,
          payload: "Something went wrong! please try again.",
        });
      });
  };

  const fixedWidthApiCall = () => {
    fixedWidthOutputMappingSave({
      id: profileId ?? 0,
      fixedWidthOutputSections: mappedData,
    })
      .then((response) => {
        setLoading(false);
        let newValues = response?.fixedWidthOutputSections
          ?.filter((_) => !_.isDeleted)
          ?.map((item) => {
            return {
              ...item,
              fixedWidthOutputSectionFields: item.fixedWidthOutputSectionFields?.filter(
                (_) => !_.isDeleted
              ),
            };
          });
        let res = {
          ...response,
          fixedWidthOutputSections: newValues,
        };
        dispatch(setMapperPostResponse(res));
        dispatch(
          setManageMapperToastInfo({
            showToast: true,
            toastMessage: "Data saved successfully",
          })
        );
        onClose();
      })
      .catch((error) => {
        setLoading(false);
        dispatch({
          type: MANAGE_MAPPER_POST_API_ERROR,
          payload: "Something went wrong! please try again.",
        });
      });
  };

  const onFormSubmit = (values) => {
    setLoading(true);
    const headerExpression = jsonToStringConverter(
      values?.headerData,
      mapType,
      true
    );
    const value = jsonToStringConverter(values?.valueData, mapType, true);
    setPreValue(value);
    const hError = hasHeader
      ? values?.headerData.value == null ||
        isNull(values?.headerData?.value?.path) ||
        (values?.headerData.parameterType == 2 &&
          (headerExpression.includes("null") ||
            headerExpression.includes("undefined")))
      : false;
    const vError =
      values?.valueData.value == null ||
      (values?.valueData.parameterType == 2 &&
        (value.includes("null") || value.includes("undefined")));
    setHeaderError(hError);
    setValueError(vError);
    if (mapType == 3) {
      if (!vError) {
        setFieldValue(
          `ruleSet[${fieldIndex}].ruleOperations[${innerFieldIndex}].${fieldName}`,
          value
        );
        setShowSlide(false);
      }
    } else {
      if (!hError && !vError) {
        const data = isEdit
          ? mappedData.map((item, i) => {
              if (i == fieldIndex)
                return {
                  id: item.id ?? 0,
                  headerExpression: headerExpression,
                  headerValue: hasHeader
                    ? stringToFunctionConverter(headerExpression, 1)
                    : values?.headerData.value,
                  value: value,
                };
              return item;
            })
          : [
              ...mappedData,
              {
                headerExpression: headerExpression,
                headerValue: hasHeader
                  ? stringToFunctionConverter(headerExpression, 1)
                  : values?.headerData.value,
                value: value,
              },
            ];
        setMappedData(data);
        apiCall(data);
      }
    }
  };

  const onClose = () => {
    setShowSlide(false);
    // setKey(isFixedWidth ? "TypeSettings" : "Header");
    // setClickToSelect(false);
    // setHeaderError(false);
    // setValueError(false);
  };

  const handleOnDragStart = (res) => {
    // setDrag(true);
  };

  const handleOnDragUpdate = (update) => {
    // const { destination } = update;
    // if (!isNull(destination)) {
    //   setDestination(destination.droppableId);
    // }
  };

  const handleOnDragEnd = (result, values, setFieldValue) => {
    setFieldArrayName(null);
    setClickToSelect(false);
    const { draggableId } = result;

    if (result.destination == null) {
      return;
    }
    if (isEqual(result.destination, result.source)) {
      return;
    }

    let draggedData = section?.fields?.find((e, i) => {
      if (e.isCollection) {
        let data = e.childObjectMaps.find((x) => x.id == draggableId);
        return data;
      } else return e.id == draggableId;
    });
    if (draggedData?.isCollection) {
      let temp = {
        ...draggedData?.childObjectMaps.find((x) => x.id == draggableId),
        isCollection: true,
        isCollectionParent: draggedData?.isCollection,
        propertyNameParent: draggedData?.propertyName,
      };
      draggedData = temp;
    }
    let droppableId = get(result, "destination.droppableId");
    if (key == "Header" && droppableId) {
      setFieldValue(droppableId, {
        ...draggedData,
        path: draggedData?.fieldName.substring(1),
        value: draggedData?.datum ?? 1000,
        displayName: draggedData?.fieldName.substring(1),
      });
    }
    if (key == "Value" && droppableId) {
      setFieldValue(droppableId, {
        ...draggedData,
        path: draggedData?.fieldName.substring(1),
        value: draggedData?.datum ?? 1000,
        displayName: draggedData?.fieldName.substring(1),
      });
    }
  };

  const sliderValues = () => {
    return {
      headerData: {
        parameterType: 0,
        value: sourceHeaderName,
      },
      valueData: stringToJsonConverter(
        mappedData ? mappedData?.trim() : "",
        section
      ),
    };
  };

  return (
    showSlide && (
      <LoaderWrapper isLoading={loading}>
        <Formik
          initialValues={sliderValues()}
          enableReinitialize
          onSubmit={onFormSubmit}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            values,
            setValues,
            errors,
            ...rest
          }) => {
            return (
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
                validated={rest.submitCount > 0}
              >
                <SliderPanel
                  flair="select-investment-merger-scroll"
                  isOpen={showSlide}
                  size="75"
                  showCancelButton={true}
                  showSave={true}
                  showCancel={false}
                  backdropClicked={() => onClose()}
                  onSave={() => onFormSubmit(values)}
                  // onSave={handleSubmit}
                  onClose={() => onClose()}
                  // showHeader={true}
                  // header="Field Setup"
                  // headerClass="slider-title-case"
                  // showSeparator={true}
                  // showDeleteButton={true}
                  // onDelete={deleteCall}
                >
                  <DragDropContext
                    onDragStart={handleOnDragStart}
                    onDragUpdate={handleOnDragUpdate}
                    onDragEnd={(x) => handleOnDragEnd(x, values, setFieldValue)}
                  >
                    <div style={{ display: "flex" }}>
                      <SourceFieldPanelComponent
                        sections={sections()}
                        handleOnDragEnd={handleOnDragEnd}
                        fieldArrayName={fieldArrayName}
                        clickToSelect={clickToSelect}
                        showSource={[0, 2].includes(sectionType) ? false : true}
                        // headerValueKey={key}
                      />
                      <div className="rules-functions-component">
                        <RuleFunctionsComponent
                          errors={errors}
                          disabledKeys={disabledKeys}
                          setDisabledKeys={setDisabledKeys}
                          setValues={setValues}
                          values={values}
                          index={index}
                          keyValue={key}
                          setKey={setKey}
                          hasHeader={hasHeader}
                          clickToSelect={clickToSelect}
                          setClickToSelect={setClickToSelect}
                          setFieldArrayName={setFieldArrayName}
                          showField={
                            [0, 2].includes(sectionType) ? false : true
                          }
                          headerError={headerError}
                          valueError={valueError}
                          fieldIndex={fieldIndex}
                        />
                      </div>
                    </div>
                  </DragDropContext>
                </SliderPanel>
              </Form>
            );
          }}
        </Formik>
      </LoaderWrapper>
    )
  );
};

export default RuleFilterSlider;
